import {lighten} from 'polished';
import styled, {keyframes} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {colors, transition} from 'theme';

export const FactoryHeading = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-left: 12px;
    margin-bottom: 25px;
`;

export const EditButton = styled(Button)`
    width: auto;
    align-self: center;
`;

export const FactoryName = styled.div`
    display: flex;
    flex-flow: column nowrap;

    p {
        color: ${colors.textMuted};
        font-size: 12px;
        margin-bottom: 0;
    }
`;

export const Title = styled.h2`
    font-size: 14px;
    font-weight: 700;
    color: ${colors.textPrimary};
`;

export const FactoryInfo = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    max-width: 1000px;
    margin-bottom: 15px;
    margin-left: 12px;
    margin-right: 12px;
    gap: 15px;
`;

export const FactoryInfoItem = styled.div`
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 5px;

    p {
        margin: 2px 0;
    }
`;

export const FactoryInfoItemTitle = styled.p`
    color: ${colors.textSecondary};
    font-size: 12px;
`;

export const FactoryInfoItemValue = styled.p`
    color: ${colors.textPrimary};
    font-size: 14px;
`;

export const LinesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    height: auto;
    grid-template-rows: auto;
`;

export const EquipmentItem = styled.div`
    display: flex;
    flex-flow: column wrap;
    border: 1px solid #e7e8ea;
    padding: 20px 24px 10px;
    cursor: pointer;
    transition: all ${transition.duration};

    &:hover {
        transform: scale(1.05);
        box-shadow: 4px 4px 8px 0 rgba(34, 60, 80, 0.2);
    }
`;

export const ItemHeadingContainer = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${colors.border};
`;

export const ItemHeadingTitle = styled.span`
    font-size: 16px;
    color: ${colors.textPrimary};
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.01em;
    // For long titles
    word-break: break-word;
    white-space: pre-wrap;
`;

export const ItemNumber = styled.span`
    font-weight: 700;
    color: ${colors.brandPrimary};
    font-size: 16px;
    margin-right: 10px;
`;

export const LineStatusTag = styled.div<{isActive: boolean}>`
    margin-left: 20px;
    padding: 7px 10px;
    font-size: 10px;
    font-weight: 500;
    border-radius: 4px;
    color: ${(p) => (p.isActive ? colors.success : colors.textMuted)};
    background-color: ${(p) =>
        p.isActive ? lighten(0.36, colors.success) : lighten(0.305, colors.textMuted)};
    cursor: default;
    white-space: nowrap;
`;

export const ItemHeadingTitleStatus = styled.span<{isActive: boolean}>`
    color: ${(p) => (p.isActive ? colors.brandPrimary : 'D9D9D')};
`;

export const ItemLabel = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    font-size: 12px;
    color: ${colors.textPrimary};
    margin-bottom: 20px;
`;

export const ItemLabelName = styled.span`
    font-size: 12px;
    color: ${colors.textMuted};
    margin-right: 10px;
`;

export const ItemLabelValue = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${colors.black};
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 280px;
    margin-right: 20px;

    animation: ${opacity} 2s ease;
`;
